// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__29ogb","dot":"styles_dot__34kHY"};